import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ef-checkbox',
    templateUrl: './ef-checkbox.component.html',
    styleUrls: ['./ef-checkbox.component.scss'],
    standalone: false
})
export class EfCheckboxComponent implements OnInit {
    @Input() rowData: any;
    @Input() property: any;
    @Input() disabled: boolean;
    constructor() {}

    ngOnInit(): void {
        // this.log.verbose('ef-checkbox ngModel: ' + this.rowData[this.property]);
    }
}
